/* Composition de boite.
   Le prix de la boite est le plus haut montant encaissable qui reste sous
   0,40 fois la valeur des soins choisis : la remise est donc toujours d'au moins
   60 pour cent, sans borner le catalogue.

   Trois regles de prudence :
   1. le prix d'un soin vient de /products/handle.js, jamais du HTML de la carte ;
   2. l'etat vit en localStorage, pour survivre aux filtres et a la pagination ;
   3. sans lien de paiement pour le montant calcule, on ne redirige pas. */
(function () {
  'use strict';

  var CLE = 'ks_boite_v1';
  /* MAXI n'est plus la regle de l'offre, c'est un garde-fou : il borne ce qu'on
     accepte de relire en localStorage et ce qu'on accepte de coller sur une ligne
     de panier. La vraie limite est le DERNIER PALIER, voir pleine(). */
  var MAXI = 40;
  var panier = [];   // { h, t, p, img, sku }
  var cache = {};
  var enCours = false;

  function coef() { return window.__KS_COEF__ || 0.40; }
  function eur(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }

  function montants() {
    return Object.keys(window.__KS_BOITE__ || {})
      .map(Number).filter(function (n) { return n > 0; })
      .sort(function (a, b) { return a - b; });
  }

  function maxiPalier() {
    var m = montants();
    return m.length ? m[m.length - 1] : 0;
  }

  /* La boite est pleine quand elle a atteint le DERNIER palier, pas quand elle
     compte un certain nombre de soins. Au-dela de ce palier le prix ne bouge
     plus : chaque soin supplementaire serait offert et la remise passerait sous
     les 60 pour cent annonces. C'est donc le montant qui borne la boite. */
  function pleine() {
    var haut = maxiPalier();
    if (!haut) return false;
    var val = panier.reduce(function (s, x) { return s + x.p; }, 0);
    return montant(val) >= haut || panier.length >= MAXI;
  }

  function montant(valeurCents) {
    var cible = valeurCents * coef(), r = 0;
    montants().forEach(function (m) { if (m <= cible) r = m; });
    return r;
  }

  function lis() {
    try {
      var b = JSON.parse(localStorage.getItem(CLE) || '[]');
      if (Object.prototype.toString.call(b) === '[object Array]') panier = b.slice(0, MAXI);
    } catch (e) {}
  }
  function ecris() {
    try { localStorage.setItem(CLE, JSON.stringify(panier)); } catch (e) {}
  }

  function fiche(h) {
    if (cache[h]) return Promise.resolve(cache[h]);
    return fetch('/products/' + h + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var v = null;
        for (var i = 0; i < p.variants.length; i++) {
          if (p.variants[i].available) { v = p.variants[i]; break; }
        }
        if (!v) v = p.variants[0];
        cache[h] = { h: h, t: p.title, p: v.price, img: p.featured_image || '', sku: v.sku || '', vid: v.id };
        return cache[h];
      });
  }

  /* ------------------------------------------------------------------ rendu */

  function $(id) { return document.getElementById(id); }

  function rendu() {
    if (!$('ksbSlots')) { marqueCartes(0, 0); return; }
    var val = panier.reduce(function (s, x) { return s + x.p; }, 0);
    var pay = montant(val);
    var n = panier.length;

    var cases = '';
    for (var i = 0; i < 4; i++) {
      var x = panier[i];
      cases += '<div class="ksb__slot' + (x ? ' ksb__slot--full' : '') + '">' +
        (x ? (x.img ? '<img src="' + x.img + '" alt="">' : '') +
             '<button type="button" data-retire="' + x.h + '" aria-label="Retirer">×</button>' : '') + '</div>';
    }
    if (n > 4) cases += '<div class="ksb__slot ksb__slot--full ksb__plus">plus ' + (n - 4) + ' autre' + (n - 4 > 1 ? 's' : '') + '</div>';
    $('ksbSlots').innerHTML = cases;

    $('ksbN').textContent = n + ' soin' + (n > 1 ? 's' : '');
    $('ksbVal').textContent = eur(val);
    $('ksbPay').textContent = pay ? eur(pay) : '—';

    var sv = $('ksbSave');
    if (pay && val > pay) {
      sv.hidden = false;
      sv.textContent = 'Tu économises ' + eur(val - pay) + ' · −' + Math.round((1 - pay / val) * 100) + ' %';
    } else sv.hidden = true;

    var cta = $('ksbCta');
    cta.disabled = !pay || enCours;
    cta.textContent = enCours ? 'Un instant…' : (pay ? 'Je prends ma boîte · ' + eur(pay) : 'Encore un peu');
    $('ksbVide').hidden = !n;

    /* Sous 900 px le plateau est la barre du bas. Elle doit rester mince tant
       que la boite est vide : une barre de 140 px sur un telephone mange un
       sixieme de l'ecran pour ne rien dire. */
    var bac = $('ksb');
    if (bac) bac.classList.toggle('ksb--plein', n > 0);

    var ouvre = $('ksbOuvre');
    ouvre.hidden = !n;
    $('ksbOuvreN').textContent = n;
    $('ksbOuvreP').textContent = pay ? eur(pay) : '—';

    marqueCartes(val, pay);
    nudge(n, val, pay);
    dessineEchelle(val, pay);
    dessineFiltreCad();
    if (ouvertPlein()) { if (!pleine()) fermePlein(); else dessinePlein(); }
  }

  function nudge(n, val, pay) {
    var el = $('ksbNudge');
    if (!el) return;
    var mini = montants()[0] || 0;
    if (!n) {
      el.className = 'ksb__nudge ksb__nudge--att';
      el.textContent = 'Clique sur un soin pour commencer ta boîte.';
      return;
    }
    if (!pay) {
      var manque = Math.ceil(mini / coef()) - val;
      el.className = 'ksb__nudge ksb__nudge--att';
      el.innerHTML = 'Encore <b>' + eur(manque) + '</b> de soins et ta boîte s’ouvre à <b>' + eur(mini) + '</b>.';
      return;
    }
    if (pleine()) {
      var hautN = maxiPalier();
      el.className = 'ksb__nudge ksb__nudge--att';
      el.innerHTML = (hautN > 0 && pay >= hautN)
        ? 'Ta boîte est au maximum, <b>' + eur(pay) + '</b>. ' +
          'Retire un soin pour en changer, ou passe au panier.'
        : 'Ta boîte est pleine, <b>' + MAXI + ' soins</b>. ' +
          'Retire un soin pour en changer, ou passe au panier.';
      return;
    }
    var offerts = document.querySelectorAll('.ksb-carte--offert').length;
    if (offerts) {
      el.className = 'ksb__nudge';
      /* Meme mot que le bandeau de la carte : un soin qui ne fait pas monter le
         prix est un cadeau, et c'est ce qui donne envie d'en ajouter un de plus.
         Cliquable : filtre le catalogue sur les seuls cadeaux du moment. */
      el.innerHTML = '<button type="button" class="ksb__nudge-btn" data-voir-cadeaux="1"><b>' +
        offerts + ' cadeau' + (offerts > 1 ? 'x' : '') + '</b> disponible' + (offerts > 1 ? 's' : '') +
        ' à ce prix, les voir</button>';
    } else {
      var suiv = 0;
      montants().forEach(function (m) { if (!suiv && m > pay) suiv = m; });
      el.className = 'ksb__nudge ksb__nudge--att';
      el.innerHTML = suiv ? 'Le prochain soin fera passer ta boîte à <b>' + eur(suiv) + '</b>.'
                          : 'Ta boîte est au maximum.';
    }
  }

  /* Un soin est « offert » quand l'ajouter ne change pas le montant a payer. */
  function marqueCartes(val, pay) {
    var bloque = pleine();
    var cartes = document.querySelectorAll('[data-ksb-h]');
    Array.prototype.forEach.call(cartes, function (c) {
      var h = c.getAttribute('data-ksb-h');
      var dedans = panier.some(function (x) { return x.h === h; });
      c.classList.toggle('ksb-carte--dedans', dedans);
      var f = cache[h];
      /* Boite pleine, plus rien n'est un cadeau : au dernier palier le prix ne
         bouge plus, donc TOUTES les cartes seraient annoncees en cadeau alors
         qu'aucune ne peut etre ajoutee. Une promesse qu'un clic dement aussitot. */
      var offert = !dedans && !bloque && !!pay && !!f && montant(val + f.p) === pay;
      c.classList.toggle('ksb-carte--offert', offert);
    });
  }

  /* Les prix des soins visibles, pour pouvoir dire lesquels sont offerts.
     Deux garde-fous indispensables :
     - on ne redemande jamais un handle deja demande, meme s'il a echoue ;
     - si rien de nouveau n'est a charger, on ne rend PAS. Sans ca, l'observateur
       du DOM rappelle precharge, qui appelle rendu, qui reecrit le DOM, qui
       rappelle l'observateur : le navigateur tourne en rond et sature. */
  var demandes = {};
  var enPrecharge = false;

  function precharge() {
    if (enPrecharge) return;
    var h = [];
    Array.prototype.forEach.call(document.querySelectorAll('[data-ksb-h]'), function (c) {
      var x = c.getAttribute('data-ksb-h');
      if (x && !cache[x] && !demandes[x] && h.indexOf(x) < 0) h.push(x);
    });
    if (!h.length) return;
    h = h.slice(0, 40);
    h.forEach(function (x) { demandes[x] = 1; });
    enPrecharge = true;
    Promise.all(h.map(function (x) {
      return fiche(x).catch(function () { return null; });
    })).then(function () { enPrecharge = false; rendu(); });
  }

  /* L'echelle des paliers : visualise ou en est la boite et ce qui devient
     cadeau une fois un palier franchi, sans dupliquer la regle du "offert" deja
     posee sur les cartes (voir marqueCartes). */
  function dessineEchelle(val, pay) {
    var el = $('ksbEchelle');
    if (!el) return;
    var m = montants();
    if (!m.length) { el.innerHTML = ''; return; }
    var offerts = document.querySelectorAll('.ksb-carte--offert').length;
    el.innerHTML = m.map(function (mnt) {
      var etat = pay && mnt < pay ? 'fait' : mnt === pay ? 'ici' : 'avenir';
      var texte;
      if (etat === 'fait') {
        texte = 'Palier franchi';
      } else if (etat === 'ici') {
        texte = offerts
          ? '<button type="button" class="ksb-ech__voir" data-voir-cadeaux="1">' + offerts +
            ' cadeau' + (offerts > 1 ? 'x' : '') + ', voir</button>'
          : 'Ta boîte est ici';
      } else {
        var manque = Math.max(0, Math.ceil(mnt / coef()) - val);
        texte = manque ? 'encore ' + eur(manque) : 'Prochain palier';
      }
      return '<div class="ksb-ech__step ksb-ech__step--' + etat + '">' +
        '<span class="ksb-ech__p">' + eur(mnt) + '</span>' +
        '<span class="ksb-ech__t">' + texte + '</span></div>';
    }).join('');
  }

  /* Filtre "voir les cadeaux" : masque tout ce qui n'est pas actuellement
     offert. Purement visuel (classe sur <body>), donc reste synchronise a
     chaque rendu meme si la composition change entre-temps. Se coupe tout
     seul si plus aucun cadeau n'est disponible, pour ne jamais laisser une
     grille vide sans explication. */
  var filtreCadeauxActif = false;

  function activeFiltreCadeaux(on) {
    filtreCadeauxActif = on;
    document.body.classList.toggle('ksb-filtre-cad-actif', on);
    dessineFiltreCad();
  }

  function dessineFiltreCad() {
    var el = $('ksbFiltreCad');
    if (!el) return;
    var offerts = document.querySelectorAll('.ksb-carte--offert').length;
    if (filtreCadeauxActif && !offerts) activeFiltreCadeaux(false);
    el.hidden = !filtreCadeauxActif;
    if (filtreCadeauxActif) {
      $('ksbFiltreCadTxt').textContent = offerts + ' cadeau' + (offerts > 1 ? 'x' : '') +
        ' affiché' + (offerts > 1 ? 's' : '') + ', le reste du catalogue est masqué.';
    }
  }

  /* --------------------------------------------------------- boite pleine

     Au MAXI-ieme soin, le clic partait dans le vide : aucune reponse, la cliente
     croyait a une panne. Le panneau lui montre tout ce qu'elle a deja, avec de
     quoi retirer N'IMPORTE LEQUEL, y compris ceux que la barre du bas ne montre
     pas, et lui propose de partir au panier.
     Il se redessine a chaque rendu tant qu'il est ouvert, et se ferme tout seul
     des qu'il reste de la place. */
  function ouvertPlein() {
    var p = $('ksbPlein');
    return p && !p.hidden;
  }

  function fermePlein() {
    var p = $('ksbPlein');
    if (p) p.hidden = true;
  }

  function montrePlein() {
    var p = $('ksbPlein');
    if (!p) return;
    p.hidden = false;
    dessinePlein();
  }

  function dessinePlein() {
    var p = $('ksbPlein');
    if (!p || p.hidden) return;

    var val = panier.reduce(function (s, x) { return s + x.p; }, 0);
    var pay = montant(val);

    /* Deux raisons possibles de ne plus pouvoir ajouter, et elles ne se disent pas
       pareil : le dernier palier, ou le garde-fou de MAXI soins quand la boite est
       remplie de tout petits prix. Annoncer le palier dans le second cas serait
       faux. */
    var haut = maxiPalier();
    var parLePalier = haut > 0 && pay >= haut;

    $('ksbPleinT').textContent = parLePalier
      ? eur(pay) + ', c’est le dernier palier'
      : MAXI + ' soins, c’est le maximum';

    $('ksbPleinP').innerHTML = !pay
      ? 'Retire un soin pour en ajouter un autre, ou file au panier.'
      : parLePalier
        ? '<b>' + panier.length + ' soins</b> pour <b>' + eur(pay) + '</b>, et <b>' + eur(val) +
          '</b> de valeur : c’est le plus gros écart que la boîte peut atteindre. ' +
          'Retire celui qui te tente le moins pour en mettre un autre, ou file au panier.'
        : 'Tu paies <b>' + eur(pay) + '</b> pour <b>' + eur(val) + '</b> de soins. ' +
          'Retire celui qui te tente le moins pour en mettre un autre, ou file au panier.';

    $('ksbPleinL').innerHTML = panier.map(function (x) {
      return '<li><span class="ksb-plein__im">' +
        (x.img ? '<img src="' + ech(x.img) + '" alt="" loading="lazy">' : '') + '</span>' +
        '<span class="ksb-plein__nom">' + ech(x.t) + '</span>' +
        '<span class="ksb-plein__pr">' + eur(x.p) + '</span>' +
        '<button type="button" class="ksb-plein__ret" data-retire="' + ech(x.h) + '">Retirer</button></li>';
    }).join('');

    var cta = $('ksbPleinCta');
    cta.disabled = !pay;
    cta.textContent = pay ? 'Voir ma boîte · ' + eur(pay) : 'Encore un peu';
  }

  /* ------------------------------------------------------------- validation */

  function valide() {
    var val = panier.reduce(function (s, x) { return s + x.p; }, 0);
    var pay = montant(val);
    if (!pay || enCours) return;
    var vid = (window.__KS_BOITE__ || {})[String(pay)];
    var lien = (window.__KS_LIENS__ || {})[pay];
    if (!vid) { alert('Ce montant n’a pas encore de boîte. Retire un soin.'); return; }
    if (!lien) { alert('Ce montant n’a pas encore de page de paiement. Retire un soin.'); return; }

    enCours = true; rendu();
    var skus = panier.map(function (x) { return x.sku || x.h; }).join(',');
    var titres = panier.map(function (x) { return x.t; }).join(' + ');
    /* Les vignettes voyagent AVEC la ligne de panier. Avant, le panier ne recevait
       que des SKU et devait les retraduire en images, un appel reseau par soin :
       lent, et gris des que le domaine limitait le debit. Ici l'image est deja
       connue, on l'ecrit. Sans parametre de taille ni de version, le panier
       redemandera la largeur qu'il veut. */
    var imgs = panier.map(function (x) {
      var u = x.img ? String(x.img).split('?')[0].split('#')[0] : '';
      if (!u) return '';
      if (u.indexOf('//') === 0) return 'https:' + u;
      if (u.indexOf('http') !== 0) return 'https://' + location.host + u;
      return u;
    }).join(',');

    /* Les cadeaux, pour que le panier les mette a part. Meme regle que sur les
       cartes : un soin est offert quand son ajout n'a pas change le montant a
       payer, la boite etant deja ouverte. On rejoue la composition dans l'ordre
       ou elle a ete faite ; le panier ne recoit que des rangs, il ne recalcule
       rien, parce qu'il n'a pas les prix. */
    var cumul = 0, avant = 0, cadeaux = [];
    panier.forEach(function (x, i) {
      cumul += x.p;
      var m = montant(cumul);
      if (avant && m === avant) cadeaux.push(i);
      avant = m;
    });
    cadeaux = cadeaux.join(',');

    fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' })
      .catch(function () {})
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [{ id: vid, quantity: 1, properties: {
            _ks_palier: String(pay), _ks_skus: skus, _ks_imgs: imgs, _ks_cadeaux: cadeaux, 'Contenu': titres
          } }] })
        });
      })
      .catch(function () {})
      .then(function () {
        /* La cliente ne part plus chez le prestataire sans avoir vu ce qu'elle
           achete : le panier s'ouvre sur sa composition, et c'est SON bouton de
           commande qui part au paiement, sur le meme lien qu'avant. Ce lien est
           construit par __KS_BOITE_URL__ (snippets/ks-liens.liquid) et appele par
           ks-cart-boite.js, qui vit avec le panier.
           Le garde-fou du haut ne bouge pas : sans lien de paiement pour ce
           montant, on ne pose meme pas la ligne. */
        enCours = false;
        rendu();
        ouvrePanier();
      });
  }

  /* Le tiroir d'Horizon ne sait rien d'un ajout fait a la main : il se recharge
     sur « cart:update », et ce rechargement passe par le serveur.

     Deux pieges, tous deux vus en test :
     - ouvrir le tiroir tout de suite montrait le panier d'AVANT, souvent vide ;
     - attendre le contenu AVANT d'ouvrir ne marchait pas sur telephone : le
       tiroir ne se remplit qu'une fois ouvert, on attendait donc quelque chose
       qui n'arrivait jamais.
     D'ou l'ordre retenu : on previent, on ouvre, puis on verifie que la
     composition est bien la. Si au bout de quatre secondes elle ne l'est pas, on
     va sur /cart, qui la rend cote serveur et ne peut pas rater. Dans tous les
     cas la cliente voit sa boite. */
  function ouvrePanier() {
    function secoue() {
      try {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: null, sourceId: 'ks-boite', data: {} }
        }));
      } catch (e) {}
    }

    secoue();

    var d = document.querySelector('cart-drawer-component');
    if (!d || typeof d.showDialog !== 'function') { window.location.href = '/cart'; return; }
    try { d.showDialog(); } catch (e) { window.location.href = '/cart'; return; }

    /* On ne se contente pas d'avoir APPELE showDialog : sur telephone il rend la
       main sans que le tiroir s'ouvre ni se remplisse. Tant qu'il n'est pas
       ouvert ET rempli, ce n'est pas bon, et au bout de quatre secondes on part
       sur /cart, qui rend la composition cote serveur et ne peut pas rater. */
    var t0 = Date.now();
    var relances = 0;
    (function verifie() {
      var ouvert = !!document.querySelector('dialog[open]') ||
                   (d.hasAttribute && d.hasAttribute('open'));
      if (ouvert && document.querySelector('ks-boite-contenu')) return;
      if (Date.now() - t0 > 4000) { window.location.href = '/cart'; return; }
      if (Date.now() - t0 > 900 * (relances + 1) && relances < 2) { relances++; secoue(); }
      setTimeout(verifie, 120);
    })();
  }

  /* ----------------------------------------------------------------- gestes */

  function branche() {
    document.addEventListener('click', function (e) {
      var ret = e.target.closest && e.target.closest('[data-retire]');
      if (ret) {
        e.preventDefault();
        var h = ret.getAttribute('data-retire');
        panier = panier.filter(function (x) { return x.h !== h; });
        ecris(); rendu(); return;
      }
      var c = e.target.closest && e.target.closest('[data-ksb-h]');
      if (c) {
        e.preventDefault(); e.stopPropagation();
        var hh = c.getAttribute('data-ksb-h');
        var i = -1;
        panier.forEach(function (x, k) { if (x.h === hh) i = k; });
        if (i > -1) { panier.splice(i, 1); ecris(); rendu(); return; }
        if (pleine()) { montrePlein(); return; }
        fiche(hh).then(function (f) {
          panier.push({ h: f.h, t: f.t, p: f.p, img: f.img, sku: f.sku });
          ecris(); rendu();
        }).catch(function () {});
        return;
      }
      /* Les gestes du panneau « boite pleine ». Le fond ferme, comme partout. */
      if (e.target.closest && e.target.closest('#ksbPleinCta')) { fermePlein(); valide(); return; }
      if (e.target.closest && (e.target.closest('#ksbPleinX') || e.target.closest('#ksbPleinSec'))) {
        e.preventDefault(); fermePlein(); return;
      }
      if (e.target.id === 'ksbPlein') { fermePlein(); return; }

      if (e.target.closest && e.target.closest('[data-voir-cadeaux]')) {
        e.preventDefault(); activeFiltreCadeaux(true); return;
      }
      if (e.target.closest && e.target.closest('#ksbFiltreCadOff')) {
        e.preventDefault(); activeFiltreCadeaux(false); return;
      }
      if (e.target.closest && e.target.closest('#ksbCta')) { valide(); return; }
      if (e.target.closest && e.target.closest('#ksbVide')) {
        panier = []; ecris(); rendu(); return;
      }
      if (e.target.closest && e.target.closest('#ksbOuvre')) {
        document.getElementById('ksb').classList.toggle('ksb--ouvert');
      }
    }, true);
  }

  /* ------------------------------------------------------------- recherche
     La recherche interroge Shopify (/search/suggest.json) et rend ses propres
     cartes, cliquables comme celles de la grille. Elle evite ainsi de recharger
     une page de 1,2 Mo pour changer trois mots.

     Deux choix de fond :
     - pendant une recherche, la grille du catalogue s'efface. Sans ca les
       resultats se posaient AU-DESSUS de milliers de produits toujours affiches,
       et on ne savait plus ce qu'on regardait ;
     - chaque reponse porte un jeton. Une reponse lente pour « ser » ne peut donc
       plus ecraser celle, deja affichee, de « serum ».
     Effacer le champ, ou la touche Echap, rend la grille. */
  var minuteur = null;
  var jeton = 0;

  function ech(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* suggest.json renvoie « 18.85 », la page ecrit « 18,85 € » partout ailleurs. */
  function prixTxt(v) {
    var n = parseFloat(String(v).replace(',', '.'));
    return isNaN(n) ? '' : n.toFixed(2).replace('.', ',') + ' €';
  }

  function vignette(u, px) {
    if (!u) return '';
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + px;
  }

  function catalogue(visible) {
    var g = document.querySelector('#MainContent > .shopify-section[id*="__main"]');
    if (g) g.classList.toggle('ksb-grille--off', !visible);
  }

  function entete(txt) {
    return '<div class="ksb-res__hd"><p class="ksb-res__n">' + txt + '</p>' +
      '<button type="button" class="ksb-res__retour" id="ksbQretour">Revenir au catalogue</button></div>';
  }

  function squelette(n) {
    var s = '';
    for (var k = 0; k < n; k++) {
      s += '<div class="ksb-r ksb-r--vide"><span class="ksb-r__im"></span>' +
        '<span class="ksb-r__b"><span class="ksb-r__ligne"></span>' +
        '<span class="ksb-r__ligne ksb-r__ligne--court"></span></span></div>';
    }
    return '<div class="ksb-res__g">' + s + '</div>';
  }

  function carte(p) {
    var im = vignette((p.featured_image && p.featured_image.url) || p.image || '', 400);
    var barre = parseFloat(p.compare_at_price_min || 0) > parseFloat(p.price || 0)
      ? '<s>' + prixTxt(p.compare_at_price_min) + '</s>' : '';
    return '<button type="button" class="ksb-r" data-ksb-h="' + ech(p.handle) + '">' +
      '<span class="ksb-r__im">' + (im ? '<img src="' + ech(im) + '" alt="" loading="lazy">' : '') + '</span>' +
      '<span class="ksb-r__b">' +
      '<span class="ksb-r__v">' + ech(p.vendor) + '</span>' +
      '<span class="ksb-r__t">' + ech(p.title) + '</span>' +
      '<span class="ksb-r__f"><span class="ksb-r__p">' + prixTxt(p.price) + barre + '</span>' +
      '<span class="ksb-r__a"></span></span>' +
      '</span></button>';
  }

  function cherche(mot) {
    var res = $('ksbQres');
    if (!res) return;
    jeton++;
    var mien = jeton;

    if (!mot || mot.length < 2) {
      res.hidden = true; res.innerHTML = ''; catalogue(true); return;
    }

    res.hidden = false;
    res.innerHTML = entete('Recherche en cours…') + squelette(6);
    catalogue(false);

    var u = '/search/suggest.json?q=' + encodeURIComponent(mot) +
      '&resources[type]=product&resources[limit]=12&resources[options][unavailable_products]=last';
    fetch(u, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (mien !== jeton) return;
        var l = ((d.resources || {}).results || {}).products || [];
        l = l.filter(function (p) { return p.handle !== 'ma-boite-de-soins'; });
        if (!l.length) {
          res.innerHTML = entete('Aucun soin pour « ' + ech(mot) + ' »') +
            '<p class="ksb-res__aide">Essaie un nom de marque, un type de soin, ou un mot plus court.</p>';
          return;
        }
        res.innerHTML = entete('<b>' + l.length + ' soin' + (l.length > 1 ? 's' : '') +
          '</b> pour « ' + ech(mot) + ' », clique pour l’ajouter à ta boîte') +
          '<div class="ksb-res__g">' + l.map(carte).join('') + '</div>';
        precharge();
      })
      .catch(function () {
        if (mien !== jeton) return;
        res.innerHTML = entete('La recherche ne répond pas. Réessaie dans un instant.');
        catalogue(true);
      });
  }

  function videRecherche() {
    var i = $('ksbQ'), x = $('ksbQx');
    clearTimeout(minuteur);
    if (i) i.value = '';
    if (x) x.hidden = true;
    cherche('');
    if (i) i.focus();
  }

  function brancheRecherche() {
    var i = $('ksbQ');
    if (!i) return;
    var x = $('ksbQx'), res = $('ksbQres');
    i.addEventListener('input', function () {
      x.hidden = !i.value;
      clearTimeout(minuteur);
      var v = i.value.trim();
      minuteur = setTimeout(function () { cherche(v); }, 280);
    });
    i.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); clearTimeout(minuteur); cherche(i.value.trim()); }
      if (e.key === 'Escape') { e.preventDefault(); videRecherche(); }
    });
    x.addEventListener('click', videRecherche);
    if (res) {
      res.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('#ksbQretour')) videRecherche();
      });
    }
  }

  var plateauPret = false;

  function attendPlateau() {
    if (plateauPret) return;
    if (!$('ksb')) { setTimeout(attendPlateau, 150); return; }
    plateauPret = true;
    brancheRecherche(); rendu(); precharge();
  }

  function demarre() {
    /* Le clic est branche TOUT DE SUITE, sur document : il ne depend d'aucun
       element de la page. Le plateau, lui, peut arriver plus tard, Horizon
       hydrate ses sections apres coup. */
    lis(); branche(); attendPlateau();

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && ouvertPlein()) { e.preventDefault(); fermePlein(); }
    });

    /* L'observateur ne surveille QUE la grille de produits, jamais le plateau ni
       les resultats de recherche, que nous reecrivons nous-memes. Et il est
       temporise : une pagination qui remplace 24 cartes ne doit declencher
       qu'un seul chargement. */
    var grille = document.querySelector('.product-grid, [class*="product-grid"]')
              || document.querySelector('#main-collection-product-grid')
              || document.querySelector('main');
    if (grille) {
      var att = null;
      new MutationObserver(function () {
        clearTimeout(att);
        att = setTimeout(precharge, 220);
      }).observe(grille, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarre);
  else demarre();
})();
